import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

import { ShadedBackgroundColorProp } from './EndpageImage';

type StyleProps = {
  backgroundColor: ShadedBackgroundColorProp;
  imageSource: string;
};
const useStyles = createUseStyles(({ brandColors: { background }, breakpoints: { md } }: CmsWrenchTheme) => {
  const mediaQueryMinScreenMD = `@media (min-width: ${md}px)`;
  return {
    container: ({ backgroundColor }: StyleProps) => ({
      background: backgroundColor
        ? `linear-gradient(to top, ${background.light2} 0%, ${background.light2} 66%, ${background[backgroundColor]} 66%, ${background[backgroundColor]} 100%)`
        : undefined,
    }),
    image: ({ imageSource }: StyleProps) => ({
      backgroundImage: `url(${imageSource})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      height: 174,
      [mediaQueryMinScreenMD]: {
        height: 375,
      },
    }),
  };
});

export default useStyles;
